module.exports = __webpack_public_path__ + "static/icons/siniestros-banner-mobile.a73c1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siniestros-banner-mobile.png
// module id = 3hZo
// module chunks = 1